var getFileExtension = function (fileName) {
    var extension = fileName.substr(fileName.lastIndexOf('.') + 1).toUpperCase();
    if (extension === 'JPG')
        return 'JPEG';
    return extension;
};
export default getFileExtension;
